import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import {
  getTenantAccessBlocked,
  handlePossibleTenantDeactivatedError,
} from './tenantAccessBlocked';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      void handlePossibleTenantDeactivatedError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      void handlePossibleTenantDeactivatedError(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount) => {
        if (getTenantAccessBlocked()) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
